import { render, staticRenderFns } from "./contact_sidebar.vue?vue&type=template&id=2b171477&scoped=true&"
import script from "./contact_sidebar.vue?vue&type=script&lang=ts&"
export * from "./contact_sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./contact_sidebar.vue?vue&type=style&index=0&id=2b171477&lang=scss&scoped=true&"
import style1 from "./contact_sidebar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b171477",
  null
  
)

export default component.exports